import { useQuery } from '@tanstack/react-query';
import type { Expense, ExpenseListFilters, ExpenseListResponse } from 'washday-sdk';
import { backendErrorsHandler } from '../../utils/Notification/BackendErrorsHandler';
import { getExpenseByIdV2, getExpensesV2 } from '../../services/expenses.service';
import { expenseKeys } from './queryKeys';

export const useGetExpenses = (
  enabled: boolean,
  storeId: string,
  filters: ExpenseListFilters
) =>
  useQuery<ExpenseListResponse>({
    enabled: enabled && !!storeId,
    queryKey: expenseKeys.list(storeId, filters),
    queryFn: async () => {
      try {
        const res = await getExpensesV2(storeId, filters);
        if (!res?.data?.data) {
          throw new Error('Expenses list response does not match the expected contract.');
        }
        return res.data.data;
      } catch (e) {
        backendErrorsHandler(e);
        throw e;
      }
    }
  });

export const useGetExpenseById = (storeId: string, expenseId: string) =>
  useQuery<Expense>({
    enabled: !!storeId && !!expenseId,
    queryKey: expenseKeys.detail(storeId, expenseId),
    queryFn: async () => {
      try {
        const res = await getExpenseByIdV2(expenseId, storeId);
        if (!res?.data?.data?.expense) {
          throw new Error('Expense detail response does not match the expected contract.');
        }
        return res.data.data.expense;
      } catch (e) {
        backendErrorsHandler(e);
        throw e;
      }
    }
  });
